import React, { Component } from 'react';
import preloader, { results } from '../preload';
import styled from 'styled-components';

const Wrap = styled.div`
  background: url('${p => preloader.get(results[p.result])}') no-repeat 0 0;
`;

function Screen(props) {
  let i = props.score.indexOf(Math.max(...props.score));
  return <Wrap result={i} />;
}

export default Screen;
